import { DateTime } from 'luxon';

export class PeselNumberHelper {
  public static isValid(peselNumber: string): boolean {
    if (!/^\d{11}$/.test(peselNumber)) return false;

    const WEIGHTS = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3] as const;
    const controlDigit = Number(peselNumber.at(-1));

    let sum = 0;
    for (const [index, weight] of WEIGHTS.entries()) {
      sum += Number(peselNumber[index]) * weight;
    }

    sum %= 10;
    return (sum === 0 ? 0 : 10 - sum) === controlDigit;
  }

  public static getBirthDate(peselNumber: string): string | null {
    if (!this.isValid(peselNumber)) return null;

    let year = Number(peselNumber.substring(0, 2));
    let month = Number(peselNumber.substring(2, 4));
    const day = Number(peselNumber.substring(4, 6));

    if (month > 80 && month < 93) {
      year += 1800;
    } else if (month > 0 && month < 13) {
      year += 1900;
    } else if (month > 20 && month < 33) {
      year += 2000;
      month -= 20;
    } else if (month > 40 && month < 53) {
      year += 2100;
      month -= 40;
    } else if (month > 60 && month < 73) {
      year += 2200;
      month -= 60;
    }

    const birthDate = DateTime.fromObject({
      year,
      month,
      day,
    });
    return birthDate.toISODate();
  }
}
